import { withProps, compose } from 'recompose';
import SelectDay from '@dpdgroupuk/fmx-ui/components/DayPicker';
import { withTrackProps } from '@dpdgroupuk/react-event-tracker';

import * as MESSAGE from '../../../../constants/message';
import { ALA_STEPS } from '../../steps';

import { ALA_DELIVERY_OPTION } from '../../../../constants/analytics';

export default compose(
  withProps(({ addStepData, goToStep }) => ({
    title: MESSAGE.DAY_OF_DELIVERY,
    subtitle: MESSAGE.SELECT_UPCOMING_DAY,
    onSelect: day => {
      addStepData({ day });
      goToStep(ALA_STEPS.SELECT_ADDRESS);
    },
  })),
  withTrackProps({
    onSelect: ALA_DELIVERY_OPTION.ON_DATE_SELECT,
  })
)(SelectDay);
